
































import { Component, Vue } from 'vue-property-decorator'
import PublishTopic from './PublishTopic.vue'
import { getSelfTopic, updateTopic, delTopic } from '@/api/api'
import moment from 'moment'

@Component({
  components: {
    PublishTopic
  }
})
export default class MinePost extends Vue {
  topicData: Array<any> = []
  pageSize: number = 10 // 分页组件的page-size
  total: number = 0 // 分页组件的total
  dialogFormVisible: boolean = false // 弹出框是否可见

  mounted() {
    this._getSelfTopic()
  }

  /**
   * 发布话题看点
   */
  releasePost(e: any): void {
    console.log(e)
    this.$confirm(`确定要发布 ${e.row.title} 吗？`)
      .then(_ => {
        this._releasePost(e.row)
      })
      .catch(_ => {})
  }

  /**
   * 删除话题看点
   */
  deletePost(e: any): void {
    console.log(e)
    this.$confirm(`确定要删除 ${e.row.title} 吗？`)
      .then(_ => {
        this._delTopic(e.row.id, e.$index)
      })
      .catch(_ => {})
  }

  /**
   * 换页
   */
  changePage(page: number): void {
    this._getSelfTopic(page)
  }

  /**
   * 弹出框提交成功的回调方法
   */
  closeDialog(): void {
    this.dialogFormVisible = false
    this._getSelfTopic()
  }

  /**
   * 状态转译成中文
   */
  stateToCn(state: string): string {
    return state === '0' ? '未发布' : '已发布'
  }

  /**
   * 接口 查询自己话题
   * @param page 页数
   * @param size 每页数量
   */
  _getSelfTopic(page: number = 1, size: number = this.pageSize): void {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    getSelfTopic({
      page,
      size
    })
      .then((res: any) => {
        load.close()
        if (res.data.code === 101) {
          const arr = res.data.result.records
          this.topicData = []
          for (let i = 0, len = arr.length; i < len; i++) {
            this.topicData.push({
              id: arr[i].topic_id,
              title: arr[i].topic_name,
              date: moment(arr[i].create_time).format('YYYY.MM.DD'),
              commentNum: arr[i].topicCommentVolume,
              state: arr[i].enable,
              imgPath: arr[i].title_img,
              context: arr[i].topic_context
            })
          }
        }
      })
      .catch(_ => {
        load.close()
      })
  }

  /**
   * 接口 发布话题看点
   * @param topic_id      话题ID
   * @param type_code     话题类型编码 默认传 talk
   * @param title_img     题图路径
   * @param topic_name    话题名称
   * @param topic_context 话题内容
   * @param topic_enable  话题状态
   */
  _releasePost(e: any) {
    updateTopic({
      topic_id: e.id,
      type_code: 'talk',
      title_img: e.imgPath,
      topic_name: e.title,
      topic_context: e.context,
      topic_enable: '1'
    })
      .then((res: any) => {
        if (res.data.code === 101) {
          this._getSelfTopic()
          this.$message.success('发布成功')
        }
      })
      .catch(() => {
        this.$message.error('网络错误,请联系管理员')
      })
  }

  /**
   * 接口 删除话题看点
   * @param topic_id 话题ID
   */
  _delTopic(id: string, index: number) {
    const load = this.$loading({
      lock: true,
      text: '删除中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    delTopic({ topic_id: id })
      .then((res: any) => {
        load.close()
        if (res.data.code === 101) {
          this.$message.success('删除成功')
          this.topicData.splice(index, 1)
        }
        console.log(res)
      })
      .catch(_ => {
        load.close()
      })
  }
}
